import React from 'react';
import { Image, Flex, Button, Box, Text, Heading, Card } from 'rebass';
import styled from 'styled-components';
import { withRouter } from 'react-router';

import { Intro } from './sections/Intro';
import { Pricings } from './sections/Pricings';
import { ThinkCare } from './sections/ThinkCare';
import SoManyPerks from '../../static/SoManyPerks.png';
import SelectPlanPage from '../selectPlanPage';
import { WhatsCovered } from './sections/components/WhatsCovered';
import { isToggleActive } from '../../components/featureToggle/toggles';
import NutritionistDashIcon from '../../static/nutritionistDashIcon.png';
import Plant from '../../static/plant.png';
import Thyroid4 from '../../static/thyroid4.png';
import CharacterHearts from '../../static/CharacterHearts.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import withSession from '../../lib/withSession';
import { MembershipBulletItem } from '../../components/MembershipBulletItem';
import { isMobile } from 'react-device-detect';
import { BecomeMemberLegacy } from '../becomeMember';
import { withApollo } from 'react-apollo';
import { MEMBERSHIP_CREATE_SESSION } from '../../graphql';
import { loadStripe } from '@stripe/stripe-js';
import theme from '../../styles/theme';
import { useState } from 'react';
import ConfirmModal from '../../components/ConfirmModal';
import { ButtonWithSelectionCircle, ButtonWithSelectionCircleSelectedMarkerIn, ButtonWithSelectionCircleSelectedMarkerOut } from '../../components/intake/components/ButtonWithSelectionCircle';

const A = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  color: #44a5ff;
  text-decoration: underline;
  cursor: pointer;
`;

const Container = styled(Flex)`
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 0 40px 0;
  overflow-x: hidden;
  @media screen and (max-width: 1200px) {
    max-width: 100vw;
    padding-left: 6px;
    padding-right: 6px;
  }
`;

const ModalInner = styled(Flex)`
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;
const Wrapper = styled(Flex)`
  flex: 1;
`;

const CardIcon = ({ membershipType }) => {
  if (membershipType === 'HormoneRebalance') {
    return (
      <Flex style={{ marginTop: '-36px', borderRadius: '50%', alignItems: 'center', justifyContent: 'center', height: '94px', width: '94px', backgroundColor: '#354E79' }}>
        <img src={Thyroid4} style={{ height: '94px', width: '94px' }} />
      </Flex>
    );
  }
  if (membershipType === 'WeightCareEssentials') {
    return (
      <Flex style={{ marginTop: '-36px', borderRadius: '50%', alignItems: 'center', justifyContent: 'center', height: '94px', width: '94px', backgroundColor: '#354E79' }}>
        <img src={NutritionistDashIcon} style={{ height: '94px', width: '94px' }} />
      </Flex>
    );
  }
  if (membershipType === 'MetabolicReset') {
    return (
      <Flex style={{ marginTop: '-36px', borderRadius: '50%', alignItems: 'center', justifyContent: 'center', height: '94px', width: '94px', backgroundColor: '#FDF1F1' }}>
        <img src={Plant} style={{ height: '94px', width: '94px' }} />
      </Flex>
    );
  }
  if (membershipType === 'CompleteHealthBoost') {
    return (
      <Flex style={{ marginTop: '-36px', borderRadius: '50%', alignItems: 'center', justifyContent: 'center', height: '94px', width: '94px', backgroundColor: '#354E79' }}>
        <img src={CharacterHearts} style={{ height: '96px', width: '94px', marginTop: '-26px' }} />
      </Flex>
    );
  }
  return null;
};

const CardMembership = ({ membershipType, title, price, billed, description, onSelect, onStartEligibility }) => {
  return (
    <Flex
      flexDirection={'column'}
      style={{
        padding: '16px',
        paddingBottom: '26px',
        position: 'relative',
        borderRadius: '20px',
        width: '241px',
        minWidth: '241px',
        marginLeft: '7px',
        marginRight: '7px',
        boxShadow: '3px 4px 15px 0px rgba(0, 0, 0, 0.15)',
        marginTop: membershipType !== 'MetabolicReset' ? '30px' : 0,
        marginBottom: membershipType !== 'MetabolicReset' ? '30px' : 0,
        background: membershipType !== 'MetabolicReset' ? 'white' : `linear-gradient(0deg, rgba(246, 162, 147, 0.40) 0%, rgba(246, 162, 147, 0.40) 44.49%, rgba(217, 74, 106, 0.40) 100%)`,
      }}
    >
      <Flex style={{}} justifyContent={'space-between'}>
        <CardIcon style={{ marginTop: '-30px' }} membershipType={membershipType} />
        <Flex flexDirection={'column'}>
          <Box style={{ background: 'white', borderRadius: '20px', opacity: membershipType !== 'MetabolicReset' ? 0 : 1, width: 'fit-content', alignSelf: 'center' }} paddingX={'9px'} paddingY={'3px'}>
            <Text style={{ fontWeight: '300', fontSize: '9px', marginLeft: '9px', marginRight: '9px' }}>Most Popular</Text>
          </Box>
          <Text style={{ lineHeight: '20px', fontSize: '12px', textAlign: 'right', marginTop: '6px' }}>
            <span style={{ fontSize: '24px' }}>${price}</span>
            /month
            <br /> billed {billed}*
          </Text>
        </Flex>
      </Flex>
      <Flex flex={1} flexDirection={'column'}>
        <Text mt={membershipType !== 'MetabolicReset' ? '12px' : '26px'} fontSize={'17px'} fontWeight={700} fontFamily={'Playfair Display'}>
          {title}
        </Text>
        <Text mt="15px" fontSize={'12px'} fontWeight={400}>
          {description}
        </Text>
      </Flex>
      {onSelect ? (
        <Button
          variant={membershipType !== 'MetabolicReset' ? 'outline' : 'primary'}
          style={{ padding: membershipType !== 'MetabolicReset' ? '4px 19px' : '6px 19px', alignSelf: 'center', width: 'fit-content', height: 'fit-content', fontWeight: 300, fontSize: '14px' }}
          mt={3}
          onClick={() => {
            onSelect(membershipType, billed);
          }}
        >
          Select this plan
        </Button>
      ) : (
        <>
          {onStartEligibility ? (
            <Button
              variant={membershipType === 'HormoneRebalance' ? 'outline' : 'primary'}
              style={{ padding: membershipType === 'HormoneRebalance' ? '4px 19px' : '6px 19px', alignSelf: 'center', width: 'fit-content', height: 'fit-content', fontWeight: 300, fontSize: '14px' }}
              mt={3}
              onClick={() => {
                onStartEligibility(membershipType);
              }}
            >
              Check my eligibility
            </Button>
          ) : null}
        </>
      )}
    </Flex>
  );
};

const TableCompare = ({ canHormoneRebalance = true, canWeightCareEssentials = true, canMetabolicReset = true, canCompleteHealthBoost = true }) => {
  return (
    <Flex flexDirection={'column'}>
      <Flex>
        <Flex flex={1} />
        {!!canHormoneRebalance && <Flex width={'118px'} />}
        {!!canWeightCareEssentials && <Flex width={'118px'} />}
        {!!canMetabolicReset && (
          <Flex
            width={'118px'}
            alignItems={'center'}
            justifyContent={'center'}
            style={{ borderRadius: '20px 20px 0 0', height: '30px', background: '#fad4cc', boxShadow: '-4px 5px 5px 2px rgba(0, 0, 0, 0.05)' }}
          >
            <Text fontSize={'12px'} mt={2}>
              Most Popular
            </Text>
          </Flex>
        )}
        {!!canCompleteHealthBoost && <Flex width={'118px'} />}
      </Flex>

      <Flex>
        <Flex flex={1} />
        {!!canHormoneRebalance && (
          <Flex width={'118px'} style={{ justifyContent: 'center', alignItems: 'center', paddingBottom: '16px', paddingTop: '12px' }}>
            <Text fontWeight={500} textAlign={'center'}>
              Hormone Rebalance
            </Text>
          </Flex>
        )}
        {!!canWeightCareEssentials && (
          <Flex width={'118px'} style={{ justifyContent: 'center', alignItems: 'center', paddingBottom: '16px', paddingTop: '12px' }}>
            <Text fontWeight={500} textAlign={'center'}>
              Weight Care Essentials
            </Text>
          </Flex>
        )}
        {!!canMetabolicReset && (
          <Flex
            width={'118px'}
            style={{
              background: '#fad4cc',
              justifyContent: 'center',
              alignItems: 'center',
              paddingBottom: '16px',
              paddingTop: '12px',
              boxShadow: '-4px 5px 5px 2px rgba(0, 0, 0, 0.05)',
            }}
          >
            <Text fontWeight={500} textAlign={'center'}>
              Metabolic Reset
            </Text>
          </Flex>
        )}
        {!!canCompleteHealthBoost && (
          <Flex width={'118px'} style={{ justifyContent: 'center', alignItems: 'center', paddingBottom: '16px', paddingTop: '12px' }}>
            <Text fontWeight={500} textAlign={'center'}>
              Complete Health Boost
            </Text>
          </Flex>
        )}
      </Flex>

      <Flex style={{ background: '#F5F5F5' }}>
        <Flex flex={1} style={{ borderBottom: '1px solid #C0D0E6' }}>
          <Text fontWeight={600} style={{ paddingLeft: '6px', paddingTop: '10px', paddingBottom: '10px' }}>
            MEMBERSHIP PERKS
          </Text>
        </Flex>
        {!!canHormoneRebalance && <Cell isChecked={false} />}
        {!!canWeightCareEssentials && <Cell isChecked={false} />}
        {!!canMetabolicReset && <Cell isChecked={false} borderColor="#efbec7" background={'#fad4cc'} hasDrop={true} />}
        {!!canCompleteHealthBoost && <Cell isChecked={false} />}
      </Flex>

      <Flex>
        <RowHeaher text={'Access to live physician visits ($60 cash or billed to insurance)'} />
        {!!canHormoneRebalance && <Cell isChecked={true} />}
        {!!canWeightCareEssentials && <Cell isChecked={true} />}
        {!!canMetabolicReset && <Cell isChecked={true} borderColor="#efbec7" background={'#fad4cc'} hasDrop={true} />}
        {!!canCompleteHealthBoost && <Cell isChecked={true} />}
      </Flex>

      <Flex>
        <RowHeaher text={'Dedicated care manager'} />
        {!!canHormoneRebalance && <Cell isChecked={true} />}
        {!!canWeightCareEssentials && <Cell isChecked={true} />}
        {!!canMetabolicReset && <Cell isChecked={true} borderColor="#efbec7" background={'#fad4cc'} hasDrop={true} />}
        {!!canCompleteHealthBoost && <Cell isChecked={true} />}
      </Flex>

      <Flex>
        <RowHeaher text={'Unlimited doctor messaging'} />
        {!!canHormoneRebalance && <Cell isChecked={true} />}
        {!!canWeightCareEssentials && <Cell isChecked={true} />}
        {!!canMetabolicReset && <Cell isChecked={true} borderColor="#efbec7" background={'#fad4cc'} hasDrop={true} />}
        {!!canCompleteHealthBoost && <Cell isChecked={true} />}
      </Flex>

      <Flex>
        <RowHeaher text={'Discount on kits and supplements'} />
        {!!canHormoneRebalance && <Cell isChecked={true} />}
        {!!canWeightCareEssentials && <Cell isChecked={true} />}
        {!!canMetabolicReset && <Cell isChecked={true} borderColor="#efbec7" background={'#fad4cc'} hasDrop={true} />}
        {!!canCompleteHealthBoost && <Cell isChecked={true} />}
      </Flex>

      <Flex style={{ background: '#F5F5F5' }}>
        <Flex flex={1} style={{ borderBottom: '1px solid #C0D0E6' }}>
          <Text fontWeight={600} style={{ paddingLeft: '6px', paddingTop: '10px', paddingBottom: '10px' }}>
            TREATMENT OPTIONS
          </Text>
        </Flex>
        {!!canHormoneRebalance && <Cell isChecked={false} />}
        {!!canWeightCareEssentials && <Cell isChecked={false} />}
        {!!canMetabolicReset && <Cell isChecked={false} borderColor="#efbec7" background={'#fad4cc'} hasDrop={true} />}
        {!!canCompleteHealthBoost && <Cell isChecked={false} />}
      </Flex>

      <Flex>
        <RowHeaher text={`Thyroid and Hashimoto's`} />
        {!!canHormoneRebalance && <Cell isChecked={true} />}
        {!!canWeightCareEssentials && <Cell isChecked={false} />}
        {!!canMetabolicReset && <Cell isChecked={true} borderColor="#efbec7" background={'#fad4cc'} hasDrop={true} />}
        {!!canCompleteHealthBoost && <Cell isChecked={true} />}
      </Flex>

      <Flex>
        <RowHeaher text={`Menopause`} />
        {!!canHormoneRebalance && <Cell isChecked={true} />}
        {!!canWeightCareEssentials && <Cell isChecked={false} />}
        {!!canMetabolicReset && <Cell isChecked={true} borderColor="#efbec7" background={'#fad4cc'} hasDrop={true} />}
        {!!canCompleteHealthBoost && <Cell isChecked={true} />}
      </Flex>

      <Flex>
        <RowHeaher text={`Weight loss`} />
        {!!canHormoneRebalance && <Cell isChecked={false} />}
        {!!canWeightCareEssentials && <Cell isChecked={true} />}
        {!!canMetabolicReset && <Cell isChecked={true} borderColor="#efbec7" background={'#fad4cc'} hasDrop={true} />}
        {!!canCompleteHealthBoost && <Cell isChecked={true} />}
      </Flex>

      <Flex>
        <RowHeaher text={`Health coaching`} />
        {!!canHormoneRebalance && <Cell isChecked={false} />}
        {!!canWeightCareEssentials && <Cell isChecked={false} />}
        {!!canMetabolicReset && <Cell isChecked={false} borderColor="#efbec7" background={'#fad4cc'} hasDrop={true} />}
        {!!canCompleteHealthBoost && <Cell isChecked={true} />}
      </Flex>
    </Flex>
  );
};

const RowHeaher = ({ text }) => {
  return (
    <Flex flex={1} style={{ paddingTop: '16px', paddingBottom: '16px', borderBottom: '1px solid #C0D0E6' }}>
      <Text style={{ paddingLeft: '6px' }}>{text}</Text>
    </Flex>
  );
};
const Cell = ({ isChecked, color = '#466389', borderColor = '#C0D0E6', background, hasDrop }) => {
  return (
    <Flex
      width={'118px'}
      alignItems={'center'}
      justifyContent={'center'}
      style={{ borderBottom: `1px solid ${borderColor}`, background: background, boxShadow: !hasDrop ? '' : '-4px 5px 5px 2px rgba(0, 0, 0, 0.05)' }}
    >
      {!!isChecked && <FontAwesomeIcon size="1x" color={color} icon={faCheck} />}
    </Flex>
  );
};

const ContainerCards = styled(Flex)`
  overflow-x: auto;
  justify-content: center;
  padding-bottom: 20px;
  padding-top: 20px;
  @media screen and (max-width: 900px) {
    padding-bottom: 24px;
    padding-top: 24px;
    justify-content: flex-start;
    max-width: 100vw;
    padding-left: 12px;
    padding-right: 12px;
    margin-left: -6px;
    margin-right: -6px;
  }
`;

const DesktopOnly = styled(Flex)`
  @media screen and (max-width: 950px) {
    display: none;
  }
`;

const MobileOnly = styled(Flex)`
  display: none;
  @media screen and (max-width: 950px) {
    display: flex;
  }
`;

const BecomeMember = ({
  history,
  onSelect,
  canCompleteHealthBoost = true,
  canHormoneRebalance = true,
  canMetabolicReset = true,
  canWeightCareEssentials = true,
  isOnSchedule = false,
  canSkip = false,
  onContinue,
  getStarted,
  expand,
  forceTitle,
  isCheckedRes,
}) => {
  const subscribe = () => {
    history.push('/subscribe-membership');
  };
  const vals = [canCompleteHealthBoost, canHormoneRebalance, canMetabolicReset, canWeightCareEssentials];

  return (
    <>
      <Container>
        <Heading fontSize="32px" textAlign="center" style={{ maxWidth: '500px', margin: '0 auto' }}>
          {forceTitle || (!isOnSchedule ? 'Personalized Treatment plans as unique as you are.' : 'Video Visits reserved for members only')}
        </Heading>
        {!!isOnSchedule && (
          <Text fontWeight={300} mt={4} textAlign={'center'}>
            Become a member to book specialist visits for $60 cash or your copay
          </Text>
        )}

        {/* <Flex mt={5} justifyContent={'center'} alignItems={['center', 'center', '']} flexDirection={['column', 'column', 'row']}> */}
        <ContainerCards mt={[2, 2, 4]} alignItems={vals.filter((x) => !!x).length < 2 ? 'flex-start' : ''}>
          {!!canHormoneRebalance && (
            <CardMembership
              membershipType={'HormoneRebalance'}
              title={'Hormone Rebalance'}
              price={'20'}
              billed={'annually'}
              description={`Get expert support for thyroid and menopause health to feel your best everyday.`}
              onSelect={subscribe}
            />
          )}
          {!!canWeightCareEssentials && (
            <CardMembership
              membershipType={'WeightCareEssentials'}
              title={'Weight Care Essentials'}
              price={'50'}
              billed={'monthly'}
              description={`Designed to help you achieve sustainable weight management. 
Lose up to 20% of your body weight*.`}
              onSelect={onSelect}
              onStartEligibility={!onSelect && !!getStarted ? getStarted : null}
            />
          )}
          {!!canMetabolicReset && (
            <CardMembership
              membershipType={'MetabolicReset'}
              title={'Metabolic Reset'}
              price={'70'}
              billed={'monthly'}
              description={`Comprehensive support for thyroid, weight, and menopause health.`}
              onSelect={onSelect}
              onStartEligibility={!onSelect && !!getStarted ? getStarted : null}
            />
          )}
          {!!canCompleteHealthBoost && (
            <CardMembership
              membershipType={'CompleteHealthBoost'}
              title={'Complete Health Boost'}
              price={'129'}
              billed={'monthly'}
              description={`Thyroid, weight, and menopause care + a personalized health coach to support you along the way.`}
              onSelect={onSelect}
              onStartEligibility={!onSelect && !!getStarted ? getStarted : null}
            />
          )}
          <DesktopOnly>
            {vals.filter((x) => !!x).length < 2 && (
              <Card
                style={{
                  flex: 'initial',
                  position: 'relative',
                  background: 'transparent',
                  padding: '14px',
                  margin: '12px',
                  paddingBottom: isMobile ? '24px' : '24px',
                  boxShadow: 'none',
                  marginBottom: '12px',
                  maxWidth: '400px',
                }}
              >
                <Flex flexDirection={'column'} style={{ zIndex: 10 }}>
                  <Text
                    style={{
                      fontWeight: 500,
                      fontSize: '16px',
                      marginBottom: '16px',
                    }}
                  >
                    Also included in your membership:
                  </Text>
                  <MembershipBulletItem showBullet={false} text="• Dedicated Care Manager" />
                  <MembershipBulletItem showBullet={false} text="• Easy medication management" />
                  <MembershipBulletItem showBullet={false} text="• Unlimited chat with your provider" />
                  <MembershipBulletItem showBullet={false} text="• The Paloma private community" />
                  <MembershipBulletItem showBullet={false} text="• Live doctor Q&A" />
                  <MembershipBulletItem showBullet={false} text="• Symptom tracker application" />
                  <MembershipBulletItem showBullet={false} text="• Online courses on thyroid health" />
                  <MembershipBulletItem showBullet={false} text="• Monthly Speaker Series " />
                  <MembershipBulletItem showBullet={false} text="• Cancel anytime " />
                </Flex>
              </Card>
            )}
          </DesktopOnly>
        </ContainerCards>

        {!!onContinue && (
          <A
            mt={4}
            style={{
              color: !canSkip ? 'transparent' : '',
            }}
            onClick={() => {
              onContinue();
            }}
          >
            Not Interested
          </A>
        )}
        {/* 
        {!!getStarted && (
          <Button mt={4} variant={'primary'} alignSelf={'center'} onClick={getStarted}>
            Get Started
          </Button>
        )} */}

        <Heading fontSize="32px" textAlign="center" mt={[4, 4, 5]} mb={4}>
          One-Size-Fits-You
        </Heading>
        <DesktopOnly flexDirection={'column'}>
          <TableCompare
            canWeightCareEssentials={canWeightCareEssentials}
            onSelect={onSelect}
            canCompleteHealthBoost={canCompleteHealthBoost}
            canHormoneRebalance={canHormoneRebalance}
            canMetabolicReset={canMetabolicReset}
          />
        </DesktopOnly>
        <MobileOnly flexDirection={'column'} style={{ padding: '0 16px' }}>
          <MembershipBulletItem showBullet bulletColor={'#344f79'} bulletOpacity="1">
            <Text style={{ marginLeft: '16px' }}>
              Access to live physician visits <br />
              <span style={{ fontSize: '14px' }}>(billed to insurance or $60 cash)</span>
            </Text>
          </MembershipBulletItem>
          <MembershipBulletItem showBullet bulletColor={'#344f79'} bulletOpacity="1">
            <Text style={{ marginLeft: '16px' }}>A Dedicated care manager</Text>
          </MembershipBulletItem>
          <MembershipBulletItem showBullet bulletColor={'#344f79'} bulletOpacity="1">
            <Text style={{ marginLeft: '16px' }}>Easy medication management</Text>
          </MembershipBulletItem>
          <MembershipBulletItem showBullet bulletColor={'#344f79'} bulletOpacity="1">
            <Text style={{ marginLeft: '16px' }}>Unlimited chat with your provider</Text>
          </MembershipBulletItem>
          <MembershipBulletItem showBullet bulletColor={'#344f79'} bulletOpacity="1">
            <Text style={{ marginLeft: '16px' }}>The Paloma private patient community</Text>
          </MembershipBulletItem>
          <MembershipBulletItem showBullet bulletColor={'#344f79'} bulletOpacity="1">
            <Text style={{ marginLeft: '16px' }}>Symptom tracker application</Text>
          </MembershipBulletItem>
          <MembershipBulletItem showBullet bulletColor={'#344f79'} bulletOpacity="1">
            <Text style={{ marginLeft: '16px' }}>Online courses on thyroid health</Text>
          </MembershipBulletItem>
          <MembershipBulletItem showBullet bulletColor={'#344f79'} bulletOpacity="1">
            <Text style={{ marginLeft: '16px' }}>Cancel anytime </Text>
          </MembershipBulletItem>
        </MobileOnly>

        {!!getStarted && (
          <Button mt={4} variant={'primary'} alignSelf={'center'} onClick={getStarted}>
            Get Started
          </Button>
        )}

        {!!expand && (
          <>
            <Pricings />
            <WhatsCovered />
            <ThinkCare />
          </>
        )}

        <Text mt={5} style={{ fontSize: '13px', opacity: 0.75 }}>
          * Not including cost of medication
        </Text>
      </Container>
    </>
  );
};

export const JoinMember = ({ history }) => {
  const subscribe = () => {
    history.push('/join-membership');
  };
  const skip = () => {
    history.push('/');
  };

  return (
    <Wrapper>
      <>
        <Container>
          <Intro subscribe={subscribe} skip={skip} />
        </Container>
      </>
    </Wrapper>
  );
};

export const JoinMemberSubscribe = ({ history }) => {
  return (
    <Wrapper>
      <SelectPlanPage isJoinFlow={true} location={(history || {}).location} />
    </Wrapper>
  );
};

const BecomeAMemberNewLoggedIn_ = ({ history, location, session, onContinue, client }) => {
  const isResult = location.search.indexOf('?showRes=true') > -1;
  const isCheckedRes = location.search.indexOf('?resChecked=true') > -1;
  const [askType, setAskType] = useState(false);
  const [interestedIn, setInterestedIn] = useState([]);
  const [selectedType, setSelectedType] = useState('');
  const [isLoadingStripe, setIsLoadingStripe] = useState(false);
  const canHypo =
    !session.isMember &&
    session.intakeStatus !== 'disqualified' &&
    !!session.diagnoseFull &&
    (!!session.diagnoseFull.hasHypo || !!session.diagnoseFull.hasHashi) &&
    !!session.eligibility &&
    !!session.eligibility.consultation &&
    session.eligibility.status !== 'no_service';

  const canMeno = (session.eligibility.canBookPerimenopause || session.eligibility.canBookPostmenopause) && !session.isMember;

  const canWL = !session.isWeightLossMember && session.weightLossIntakeStatus !== 'disqualified' && session.eligibility.canBookWeightLoss;
  // console.log({ session });
  // if (!!canHypo && !canWL) {
  //   return <BecomeMemberLegacy />;
  // }

  const goToPurchase = async (membershipType, cancelUrl, price) => {
    setIsLoadingStripe(true);
    let priceId = window._env_.REACT_APP_MEMBERSHIP_SKU_ANNUAL_WEIGHT_LOSS;

    switch (membershipType) {
      case 'HormoneRebalance':
        priceId = window._env_.REACT_APP_MEMBERSHIP_SKU_ANNUAL_2024;
        break;
      case 'WeightCareEssentials':
        priceId = window._env_.REACT_APP_MEMBERSHIP_SKU_ANNUAL_WEIGHT_LOSS;
        break;
      case 'MetabolicReset':
        priceId = window._env_.REACT_APP_MEMBERSHIP_SKU_ANNUAL_METABOLIC_RESET;
        break;
      case 'CompleteHealthBoost':
        priceId = window._env_.REACT_APP_MEMBERSHIP_SKU_ANNUAL_COMPLETE_HEALTH_BOOST;
        break;

      default:
        break;
    }
    const createSession = await client.mutate({
      mutation: MEMBERSHIP_CREATE_SESSION,
      variables: {
        priceId: priceId,
        forwardUrl: `become-member-success?p=${price}`,
        cancel_url: cancelUrl || 'become-member?showRes=true',
        trial: false,
      },
    });

    const stripePromise = loadStripe(window._env_.REACT_APP_STRIPE_KEY);
    const stripe = await stripePromise;
    await stripe.redirectToCheckout({
      sessionId: createSession.data.createCheckoutSession.sessionId,
    });
    setIsLoadingStripe(false);
  };
  return (
    <Flex flexDirection={'column'}>
      {isResult && (
        <Flex style={{ paddingTop: '30px', paddingBottom: '60px', background: '#1D3457' }} justifyContent={'center'} alignItems={'center'} flexDirection={'column'}>
          <svg width="473" height="91" viewBox="0 0 473 91" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M186.894 14.9651L207.956 6.03125L228.479 14.9651L240.324 37.1168L228.479 59.1379L207.956 68.8438L186.894 59.1379L177.199 37.1168L186.894 14.9651Z" fill="#44A5FF" />
            <path d="M224.152 28.1414L204.465 47.8289L195.441 38.8055L197.755 36.4922L204.465 43.1859L221.839 25.8281L224.152 28.1414Z" fill="white" />
            <path d="M94.972 48.3806C107.68 54.2258 110.88 59.6056 108.722 73.3806" stroke="#FF4A4A" strokeWidth="3" />
            <path d="M307.825 65.7223C318.763 69.1565 335.286 71.8797 342.341 90.2102" stroke="#FD95D4" strokeWidth="3" />
            <path d="M15.9715 17.9073C9.04771 24.0219 9.0752 22.2823 0.637695 22.2823" stroke="#7800FF" strokeWidth="3" />
            <path d="M430.389 58.9192C437.723 53.3024 437.574 55.0359 445.991 55.6243" stroke="#D8D237" strokeWidth="3" />
            <rect x="129.699" y="77.2812" width="4.375" height="4.375" fill="#0041FF" />
            <rect x="464.699" y="21.6562" width="4.375" height="4.375" fill="#974AF5" />
            <rect x="66.5742" y="32.2812" width="4.375" height="4.375" fill="#41DCFF" />
            <rect x="151.236" y="0.375" width="6.25" height="6.25" transform="rotate(40.6027 151.236 0.375)" fill="#0041FF" />
            <rect x="363.143" y="29.7812" width="8.125" height="8.125" transform="rotate(40.6027 363.143 29.7812)" fill="#DB8FFE" />
            <rect x="35.0176" y="74.7812" width="6.25" height="6.25" transform="rotate(40.6027 35.0176 74.7812)" fill="#FF5630" />
            <rect x="468.143" y="81.6562" width="6.25" height="6.25" transform="rotate(40.6027 468.143 81.6562)" fill="#FF5630" />
            <rect x="278.43" y="18.0781" width="6.25" height="6.25" transform="rotate(9.75028 278.43 18.0781)" fill="#12AC46" />
          </svg>

          <Heading style={{ fontSize: '50px', color: 'white', marginTop: '40px', marginBottom: '34px' }}>You’re Eligible</Heading>
          <Text style={{ color: 'white', textAlign: 'center', fontSize: '20px', fontWeight: 400, maxWidth: 'min(625px, 90vw' }}>
            Our membership program gives you the highest level of care to take the guesswork out of managing your condition.
          </Text>
        </Flex>
      )}
      {/* {!!askType ? ( */}
      {/* ) : ( */}
      <BecomeMember
        history={history}
        isCheckedRes={isCheckedRes}
        canCompleteHealthBoost={!!canHypo || !!canWL}
        canHormoneRebalance={!!canHypo || !!canMeno}
        canMetabolicReset={!!canHypo || !!canMeno || !!canWL}
        canWeightCareEssentials={!!canWL}
        isOnSchedule={false}
        forceTitle={!!isResult ? 'Pick Your Plan' : null}
        onSelect={
          isCheckedRes || (!canWL && (canHypo || canMeno))
            ? (membershipType, price) => {
                goToPurchase(membershipType, null, price);
                // onSubscribe(membershipType);
              }
            : !isResult
              ? null
              : (membershipType, price) => {
                  goToPurchase(membershipType, null, price);
                  // onSubscribe(membershipType);
                }
        }
        getStarted={
          isResult
            ? null
            : (membershipType) => {
                setSelectedType(membershipType);
                // console.log({ membershipType });
                // return
                if (membershipType !== 'WeightCareEssentials' && !!canWL && !!canHypo) {
                  setAskType(true);
                  return;
                }
                if (!canWL) {
                  goToPurchase(membershipType);
                  return;
                }
                history.push('/wlm-become-member');
              }
        }
        expand
      />
      <ConfirmModal
        confirmLabel="OK"
        childrenManaged
        isOpen={askType}
        okOnly
        onClose={() => setAskType(false)}
        onConfirm={() => setAskType(false)}
        onBackgroundClick={() => setAskType(false)}
        onEscapeKeydown={() => setAskType(false)}
      >
        <ModalInner>
          <Flex flexDirection={'column'} style={{ justifyContent: 'center', alignItems: 'center' }}>
            <Flex style={{ paddingTop: '30px', paddingBottom: '60px' }} justifyContent={'center'} alignItems={'center'} flexDirection={'column'}>
              <Text fontSize={'18px'}>What type of care are you looking for?</Text>
              <Text fontSize={'14px'}>(Select all that apply)</Text>

              <ButtonWithSelectionCircle
                type="button"
                variant={'white'}
                mt={4}
                style={{ width: '80%' }}
                onClick={() => {
                  if (interestedIn.indexOf('Thyroid') > -1) {
                    setInterestedIn([...interestedIn.filter((x) => x !== 'Thyroid')]);
                  } else {
                    setInterestedIn([...interestedIn, 'Thyroid']);
                  }
                }}
                // disabled={(!!upcomingsWeightLoss && upcomingsWeightLoss.length > 0) || isRestrictedWeightloss()}
              >
                <Flex>
                  <ButtonWithSelectionCircleSelectedMarkerOut>{interestedIn.indexOf('Thyroid') > -1 && <ButtonWithSelectionCircleSelectedMarkerIn />}</ButtonWithSelectionCircleSelectedMarkerOut>
                  <Flex flex={1} flexDirection="column">
                    <Text textAlign="left" mt="4px">
                      Thyroid / Hashimoto's
                    </Text>
                  </Flex>
                </Flex>
              </ButtonWithSelectionCircle>

              <ButtonWithSelectionCircle
                type="button"
                variant={'white'}
                style={{ width: '80%' }}
                mt={3}
                onClick={() => {
                  if (interestedIn.indexOf('Weightloss') > -1) {
                    setInterestedIn([...interestedIn.filter((x) => x !== 'Weightloss')]);
                  } else {
                    setInterestedIn([...interestedIn, 'Weightloss']);
                  }
                }}
                // disabled={(!!upcomingsWeightLoss && upcomingsWeightLoss.length > 0) || isRestrictedWeightloss()}
              >
                <Flex>
                  <ButtonWithSelectionCircleSelectedMarkerOut>{interestedIn.indexOf('Weightloss') > -1 && <ButtonWithSelectionCircleSelectedMarkerIn />}</ButtonWithSelectionCircleSelectedMarkerOut>
                  <Flex flex={1} flexDirection="column">
                    <Text textAlign="left" mt="4px">
                      Weightloss
                    </Text>
                  </Flex>
                </Flex>
              </ButtonWithSelectionCircle>
              {session &&
                session.eligibility &&
                (session.eligibility.canBookPerimenopause || session.eligibility.canBookPostmenopause) && (
                  <>
                    <ButtonWithSelectionCircle
                      type="button"
                      variant={'white'}
                      mt={3}
                      style={{ width: '80%' }}
                      onClick={() => {
                        if (interestedIn.indexOf('Post menopause') > -1) {
                          setInterestedIn([...interestedIn.filter((x) => x !== 'Post menopause')]);
                        } else {
                          setInterestedIn([...interestedIn, 'Post menopause']);
                        }
                      }}
                      // disabled={(!!upcomingsWeightLoss && upcomingsWeightLoss.length > 0) || isRestrictedWeightloss()}
                    >
                      <Flex>
                        <ButtonWithSelectionCircleSelectedMarkerOut>
                          {interestedIn.indexOf('Post menopause') > -1 && <ButtonWithSelectionCircleSelectedMarkerIn />}
                        </ButtonWithSelectionCircleSelectedMarkerOut>
                        <Flex flex={1} flexDirection="column">
                          <Text textAlign="left" mt="4px">
                            Menopause
                          </Text>
                        </Flex>
                      </Flex>
                    </ButtonWithSelectionCircle>
                    <ButtonWithSelectionCircle
                      type="button"
                      variant={'white'}
                      mt={3}
                      style={{ width: '80%' }}
                      onClick={() => {
                        if (interestedIn.indexOf('Peri menopause') > -1) {
                          setInterestedIn([...interestedIn.filter((x) => x !== 'Peri menopause')]);
                        } else {
                          setInterestedIn([...interestedIn, 'Peri menopause']);
                        }
                      }}
                      // disabled={(!!upcomingsWeightLoss && upcomingsWeightLoss.length > 0) || isRestrictedWeightloss()}
                    >
                      <Flex>
                        <ButtonWithSelectionCircleSelectedMarkerOut>
                          {interestedIn.indexOf('Peri menopause') > -1 && <ButtonWithSelectionCircleSelectedMarkerIn />}
                        </ButtonWithSelectionCircleSelectedMarkerOut>
                        <Flex flex={1} flexDirection="column">
                          <Text textAlign="left" mt="4px">
                            Peri menopause
                          </Text>
                        </Flex>
                      </Flex>
                    </ButtonWithSelectionCircle>
                  </>
                )}
              {/* <Button
                variant={'outline'}
                mt={4}
                onClick={() => {
                  setInterestedIn('Thyroid');
                  setAskType(false);
                  goToPurchase(selectedType, 'become-member');
                }}
              >
                Thyroid
              </Button> */}
              {/* <Button
                variant={'outline'}
                mt={3}
                onClick={() => {
                  setInterestedIn('Thyroid + Weightloss');
                  setAskType(false);
                  history.push('/wlm-become-member');
                }}
              >
                Thyroid + Weightloss
              </Button> */}
              {/* <Button
                variant={'outline'}
                mt={3}
                onClick={() => {
                  setInterestedIn('Weightloss');
                  setAskType(false);
                  history.push('/wlm-become-member');
                }}
              >
                Weightloss
              </Button> */}
              <Button
                variant={'primary'}
                mt={4}
                disabled={!interestedIn || interestedIn.length < 1 || isLoadingStripe}
                onClick={async () => {
                  if (interestedIn.indexOf('Weightloss') < 0) {
                    await goToPurchase(selectedType, 'become-member');
                    setAskType(false);
                  } else {
                    setAskType(false);
                    history.push('/wlm-become-member');
                  }
                }}
              >
                {!isLoadingStripe ? 'Confirm' : 'Please wait...'}
              </Button>
            </Flex>
          </Flex>
        </ModalInner>
      </ConfirmModal>
      {/* )} */}
    </Flex>
  );
};

export const BecomeAMemberNewLoggedIn = withRouter(withSession(withApollo(BecomeAMemberNewLoggedIn_)));

export default withRouter(BecomeMember);
